import { useState, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LuInfo, LuMail } from 'react-icons/lu'
import { Modal } from '@asus-common/fe-ui-shadcn'
import {
  AccessProfile,
  RequestPasswordResetStep,
  MODAL_TITLE_KEY_BY_STEP,
  NEXT_STEP,
} from '@/features/auth/lib/utils'
import { useAuthUiStore } from '@/features/auth/store'
import { EmailStep, InternalInfoStep, ProfileStep } from './components'

const MODAL_ICON_BY_STEP: Record<RequestPasswordResetStep, ReactNode> = {
  [RequestPasswordResetStep.Profile]: undefined,
  [RequestPasswordResetStep.InternalInfo]: <LuInfo />,
  [RequestPasswordResetStep.Email]: <LuMail />,
}

export function RequestPasswordResetModal() {
  const { t } = useTranslation('reset-password')
  const closeModal = useAuthUiStore(s => s.closeRequestPasswordResetModal)
  const [step, setStep] = useState<RequestPasswordResetStep>(
    RequestPasswordResetStep.Profile,
  )
  const [profile, setProfile] = useState<AccessProfile | null>(null)

  const onContinue = () => {
    if (!profile) return
    setStep(NEXT_STEP[profile])
  }

  return (
    <Modal
      size="sm"
      open
      onOpenChange={open => {
        if (!open) closeModal()
      }}
      title={t(MODAL_TITLE_KEY_BY_STEP[step])}
      icon={MODAL_ICON_BY_STEP[step]}
      hasClose
      closeOnOverlayClick={false}
    >
      {step === RequestPasswordResetStep.Profile && (
        <ProfileStep
          profile={profile}
          onProfileChange={setProfile}
          onContinue={onContinue}
        />
      )}

      {step === RequestPasswordResetStep.InternalInfo && <InternalInfoStep />}

      {step === RequestPasswordResetStep.Email && <EmailStep />}
    </Modal>
  )
}
